import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { isBlogPostProjectType, isLongFormProjectType, PROJECT_TYPE } from 'src/data/project';
import { TEMPLATE_BUILDER_PARAMS } from 'src/data/template';

import { customToolDataPropTypes } from '../../lib';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  projectType: PropTypes.oneOf(Object.values(PROJECT_TYPE)),
  customToolData: customToolDataPropTypes,
};

const defaultProps = {
  className: '',
  projectType: null,
  customToolData: null,
};

export const TemplateTag = ({ className, projectType, customToolData }) => {
  const styles = useStyles();

  const title = getTemplateTitle({ projectType, customToolData });

  return (
    <CustomTypography
      className={cx(className, styles.root)}
      variant={TYPOGRAPHY_VARIANT.medium12}
    >
      {title}
    </CustomTypography>
  );
};

TemplateTag.displayName = 'TemplateTypeTag';
TemplateTag.propTypes = propTypes;
TemplateTag.defaultProps = defaultProps;

const getTemplateTitle = ({ projectType, customToolData }) => {
  if (isBlogPostProjectType(projectType)) {
    return 'Blog wizard';
  }

  if (isLongFormProjectType(projectType)) {
    return 'Long-form editor';
  }

  if (customToolData?.templateType === TEMPLATE_BUILDER_PARAMS.csv) {
    return 'CSV template';
  }

  return 'Short-form editor';
};
